<template>
  <table class="table" :id="dataTable.id">
    <thead>
      <tr>
        <th>Nome</th>
        <th>Descrição</th>
        <th class="text-center">Status</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="role in roles" :key="role.id">
        <td>{{ role.name }}</td>
        <td>{{ role.description }}</td>
        <td class="text-center" v-html="statusTranslate(role.status)" />
        <td class="text-center">
          <router-link
            :to="`roles/${role.id}`"
            class="btn btn-outline-primary btn-icon rounded-pill"
            title="Detalhes"
          >
            <i class="ph-file-text" />
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'ListRoles',

  props: {
    roles: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListRoles',
        columnDefs: [
          {
            targets: [3],
            orderable: false,
            width: 100,
          },
        ],
      },
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
